export function toGroupName(name: string) {
  if (!name) return name;
  return name
    .trim()
    .toLowerCase()
    .replace(/\s+/g, `-`)
    .replace(/[^a-z0-9\-]/g, ``);
}
